import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
  Paper,
  Fade,
  ToggleButton
} from '@mui/material';
import { useGame } from '../contexts/GameContext';
import AufzaehlungRound from './rounds/AufzaehlungRound';

const roundTypeLabels = {
  REGEL: 'Regelrunden',
  FRAGE: 'Fragerunden',
  PANTOMIME: 'Pantomime',
  ZEICHNEN: 'Zeichenrunden',
  WER_HAT: '"Wer hat..."-Runden',
  ZUFALLSEREIGNIS: 'Zufallsereignisse',
  DUELL: 'Duellrunden',
  AUFZAHLUNG: 'Aufzählungsrunden'
};

export default function PlayerSetup() {
  const [playerName, setPlayerName] = useState('');
  const { state, addPlayer, startGame, toggleRoundType } = useGame();

  const handleAddPlayer = (e) => {
    e.preventDefault();
    if (playerName.trim()) {
      addPlayer(playerName.trim());
      setPlayerName('');
    }
  };

  const atLeastTwoRoundsEnabled = Object.values(state.enabledRounds).filter(Boolean).length >= 2;

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <Fade in timeout={800}>
        <Typography 
          variant="h3" 
          component="h1" 
          gutterBottom 
          align="center"
          sx={{ 
            mb: 4, 
            fontWeight: 'bold',
            background: 'linear-gradient(45deg, #90caf9 30%, #f48fb1 90%)',
            backgroundClip: 'text',
            textFillColor: 'transparent',
          }}
        >
          FOGW
        </Typography>
      </Fade>

      <Fade in timeout={1000}>
        <Paper 
          sx={{ 
            p: 3, 
            mb: 3,
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
            },
          }}
        >
          <form onSubmit={handleAddPlayer}>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                fullWidth
                label="Spielername"
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                variant="outlined"
                placeholder="Name..."
                autoComplete="off"
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!playerName.trim()}
                sx={{ minWidth: '120px' }}
              >
                Hinzufügen
              </Button>
            </Box>
          </form>
        </Paper>
      </Fade>

      {state.players.length > 0 && (
        <Fade in timeout={1200}>
          <Paper 
            sx={{ 
              p: 3,
              mb: 3,
              boxShadow: 3,
              '&:hover': {
                boxShadow: 6,
              },
            }}
          >
            <Typography variant="h6" gutterBottom>
              Spieler ({state.players.length}):
            </Typography>
            <List>
              {state.players.map((player, index) => (
                <ListItem 
                  key={index}
                  sx={{
                    borderRadius: 2,
                    mb: 1,
                    bgcolor: 'background.default',
                  }}
                >
                  <ListItemText 
                    primary={player.name}
                    sx={{ pl: 1 }}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Fade>
      )}

      {/* Rundentypen-Auswahl */}
      <Fade in timeout={1000}>
        <Paper 
          sx={{ 
            p: 3,
            mb: 3,
            boxShadow: 3,
            '&:hover': {
              boxShadow: 6,
            },
          }}
        >
                    {state.players.length >= 2 && (
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={startGame}
              disabled={!atLeastTwoRoundsEnabled}
              sx={{ 
                mt: 0,
                mb: 3,
                fontSize: '1.1rem',
                py: 1.5,
              }}
            >
              Spiel Starten
            </Button>
          )}
          <Typography variant="h6" gutterBottom>
            Rundentypen:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {Object.entries(roundTypeLabels).map(([type, label]) => (
              <ToggleButton
                key={type}
                value={type}
                selected={state.enabledRounds[type]}
                onChange={() => toggleRoundType(type)}
                disabled={state.enabledRounds[type] && !atLeastTwoRoundsEnabled}
                color="primary"
                sx={{ 
                  justifyContent: 'flex-start',
                  py: 1,
                  px: 2,
                  textTransform: 'none'
                }}
              >
                {label}
              </ToggleButton>
            ))}
          </Box>
          {!atLeastTwoRoundsEnabled && (
            <Typography 
              variant="caption" 
              color="error"
              sx={{ display: 'block', mt: 1 }}
            >
              Mindestens zwei Rundentypen müssen aktiviert sein
            </Typography>
          )}


        </Paper>
      </Fade>
    </Box>
  );
} 